export class TokenWrapper {
  constructor(public access: string, public refresh: string) {}
}
